<!--
/*******************************************************************************
*@ 컴포넌트명   : MyAccountsLnTab.vue
*@ 컴포넌트설명 : 전계좌조회 - 대출 
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <template v-if="lnAcn">
      <account-box-header v-show="openDetail" :summary="brifLnAcn" />
      <account-box :acn-list="lnAcn" :page="`myAccount`" />
    </template>
    <template v-else>
      <!-- 조회결과가 없음 -->
      <div class="empty">
        <div class="empty-img">
          <i class="icon icon-opt-no" />
        </div>
        <strong class="empty-text">{{ /*조회 내역이 없습니다.*/ $t("MCOM-0000015") }}</strong>
      </div>
    </template>
  </article>
</template>

<script>
import { mapGetters } from "vuex";
import AccountBoxHeader from "@/components/page/accounts/AccountBoxHeader";
import AccountBox from "@/components/page/accounts/AccountBox";
export default {
  name: "MyAccountsLnTab",
  props: {
    openDetail: {
      type: Boolean,
      required: true,
    },
    showDetail: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    AccountBoxHeader,
    AccountBox,
  },
  mounted() {
    if (this.brifLnAcn) {
      this.showDetailData = true;
    } else {
      this.showDetailData = false;
    }
  },
  computed: {
    ...mapGetters("accounts/myAccounts", ["getLnAccountBox"]),
    brifLnAcn() {
      if (this.getLnAccountBox) {
        return this.getLnAccountBox.summary;
      } else {
        return [];
      }
    },
    lnAcn() {
      if (this.getLnAccountBox) {
        return this.getLnAccountBox.data;
      } else {
        return [];
      }
    },
    showDetailData: {
      get() {
        return this.showDetail;
      },
      set(value) {
        this.$emit("update:showDetail", value);
      },
    },
  },
  methods: {},
};
</script>